import React from 'react';
import './Dpharmacy.css';
import imaged from "./IMAGE/WhatsApp Image 2024-12-13 at 12.28.35.jpeg";
const Dpharmacy = () => {
  return (
    <div className='main-container-dpharmacy'>
      <h1 className='title'>D.Pharmacy</h1>
      <img 
        src={imaged}
        alt='D.Pharmacy' 
        className='image'
      />
      <p className='description'>
        Affiliated with Pt. B.D. Sharma (Rohtak), PTLRCPH was established in 2019 and offers a two-years Diploma in Pharmacy (D.Pharm). 
        Pharmacy is a branch of health science that deals with the preparation and dispensing of drugs, ensuring their safe and effective use.
      </p>
      <h2 className='sub-title'>Core Disciplines:</h2>
      <ul className='lisat'>
        <li>Pharmaceutics</li>
        <li>Medicinal Chemistry & Pharmacognosy</li>
        <li>Pharmacy Practice</li>
      </ul>
      <h2 className='sub-title'>About the Program:</h2>
      <p className='description'>
        D.Pharm is a two-years full-time program for students who have completed their 12th standard. This training equips students to work in hospital and community pharmacies as pharmacists and assists the pharmaceutical industry at various levels.
      </p>
    </div>
  );
};

export default Dpharmacy;